/* RARE FORM — smooth, “slow” scroll only */
(function () {
  // Respect users who prefer less motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if (typeof Lenis === 'undefined') return;

  const lenis = new Lenis({
    duration: 0.1,                 // 1.0 = snappier, 1.6 = floatier
    easing: t => 1 - Math.pow(1 - t, 3), // gentle ease-out (Forner-ish)
    smoothWheel: true,
    smoothTouch: false              // leave touch native; flip to true if you want it on mobile
  });

  // make it available for quick tests: lenis.scrollTo(1000)
  window.lenis = lenis;

  // drive Lenis every frame
  function raf(time){ lenis.raf(time); requestAnimationFrame(raf); }
  requestAnimationFrame(raf);

  // Pause smoothing while your RF menu overlay is open
  const syncMenu = () => (
    document.body.classList.contains('rf-open') ? lenis.stop() : lenis.start()
  );
  syncMenu();
  new MutationObserver(syncMenu).observe(document.body, { attributes:true, attributeFilter:['class'] });
})();
